/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react'
import { Form, Select, Avatar } from 'antd'
import { Controller } from 'react-hook-form'
import { InfoCircleOutlined } from '@ant-design/icons'
import openTaskImg from '@/assets/svg/tasks/openTask.svg'
import { BASE_URLS, ENVIRONMENT_MODE } from '@/config/constants'

const { Option, OptGroup } = Select
const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL

type OptionType = {
  label?: string
  value?: string
}
export interface SelectFieldProps {
  fieldname: string
  isRequired?: boolean
  avatar?: boolean
  optionGroup?: boolean
  optonDisabled?: boolean
  openOptonDisabled?: boolean
  label: string | null
  validate?: any
  validMessage?: any
  className?: string
  departmentName?: string
  hintMessage?: string
  control: any
  initValue?: any
  rules?: any
  onSelectChange?: any
  prefix?: any
  iProps?: any
  openTask?: any
  selectOption: Array<OptionType>
  tooltipTitle?: string
  optionalLabel?: string
  showOptionTooltip?: boolean
}

const SelectField: React.FunctionComponent<SelectFieldProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  selectOption,
  prefix,
  hintMessage,
  onSelectChange,
  avatar,
  optionGroup,
  openTask,
  optonDisabled,
  openOptonDisabled,
  departmentName,
  tooltipTitle,
  showOptionTooltip,
  optionalLabel,
}: SelectFieldProps) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      label={label ?? null}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          icon: <InfoCircleOutlined style={{ color: '#505560', fontSize: '14px' }} />,
        }
      }
    >
      <Controller
        name={fieldname}
        control={control}
        defaultValue={initValue ?? null}
        rules={rules}
        render={({ field: { onChange, value, onBlur } }) => (
          <>
            {prefix && <div className="select_prefix">{prefix}</div>}
            <Select
              // suffixIcon={<ArrowIcon />}
              {...iProps}
              value={value ?? ''}
              showSearch
              optionFilterProp="children"
              // getPopupContainer={(trigger: any) => trigger.parentNode}
              // filterOption={(input: any, option: any) => console.log('input, ', input, option)}
              filterOption={(input: any, option: any) =>
                option?.label
                  ? option?.label?.toLowerCase()?.includes(input?.toLowerCase())
                  : option?.children?.toString()?.includes(input)
              }
              onChange={(e, k) => {
                onChange(e)
                onSelectChange(k)
              }}
            >
              {openTask && (
                <Option value="" label="Open Task" disabled={openOptonDisabled ?? false}>
                  <div className="option-label-item">
                    {avatar && (
                      <span role="img" aria-label="Open Task">
                        <Avatar size={28} src={openTaskImg} />
                      </span>
                    )}
                    <span>Open Task</span>
                  </div>
                </Option>
              )}
              {optionGroup
                ? selectOption &&
                  Object.keys(selectOption)?.length > 0 &&
                  Object.entries(selectOption)?.map(([k, v]: any, i: number) => (
                    <Fragment key={k + i}>
                      <OptGroup label={k?.replace('_', ' ')}>
                        {v &&
                          v?.length > 0 &&
                          v?.map((e: any, ind: number) => (
                            <Option
                              value={e?.value}
                              label={e?.label}
                              key={e?.group_type ? `${e?.group_type}_${ind}` : e?.value}
                              disabled={optonDisabled ?? false}
                            >
                              <div className="option-label-item">
                                {avatar && (
                                  <span role="img" aria-label={e?.label}>
                                    {e?.image ? (
                                      <Avatar size={28} src={e?.image} />
                                    ) : (
                                      <Avatar size={28}>{e?.initials}</Avatar>
                                    )}
                                  </span>
                                )}
                                <span>{e?.label}</span>
                              </div>
                            </Option>
                          ))}
                      </OptGroup>
                    </Fragment>
                  ))
                : selectOption &&
                  selectOption?.map((resp: any, i: number) => (
                    <Fragment key={resp?.value + i}>
                      {/* <Option value={resp?.value}>{resp?.label}</Option> */}
                      <Option value={resp?.value} label={resp?.label}>
                        {showOptionTooltip ? (
                          <div className="option-label-item" title={resp.label}>
                            {avatar && (
                              <span role="img" aria-label={resp?.label}>
                                {resp?.image ? (
                                  <Avatar size={28} src={resp?.image} />
                                ) : (
                                  <Avatar size={28}>{resp?.initials}</Avatar>
                                )}
                              </span>
                            )}
                            <span>{resp?.label}</span>
                            {resp?.details && <span className="detail_label">{resp?.details}</span>}
                          </div>
                        ) : (
                          <div className="option-label-item">
                            {avatar && (
                              <span role="img" aria-label={resp?.label}>
                                {resp?.image ? (
                                  <Avatar size={28} src={resp?.image} />
                                ) : (
                                  <Avatar size={28}>{resp?.initials}</Avatar>
                                )}
                              </span>
                            )}
                            <span>{resp?.label}</span>
                            {resp?.details && <span className="detail_label">{resp?.details}</span>}
                          </div>
                        )}
                      </Option>
                    </Fragment>
                  ))}
            </Select>
            {optionalLabel && <div className="optional-label">(Optional)</div>}
            {hintMessage && <div className="hint_text">{hintMessage}</div>}
          </>
        )}
      />
    </Form.Item>
  )
}

export default SelectField
